"use client"
import { useEffect } from "react"
import Hero from "../components/Hero"
import ApartmentListings from "../components/ApartmentListings"
import BlogSection from "../components/BlogSection"
import About from "../components/About"
import Contact from "../components/Contact"
import Map from "../components/Map"
import { ScrollReveal, ParallaxSection } from "../components/ScrollReveal"

const HomePage = () => {
  // גלילה לראש הדף בעת טעינה
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Hero />
      
      <ScrollReveal direction="up" delay={0.2} duration={0.8}>
        <ApartmentListings />
      </ScrollReveal>
      
      <ParallaxSection speed={0.15} className="parallax-blog-section">
        <ScrollReveal direction="up" delay={0.3} duration={0.8}>
          <BlogSection />
        </ScrollReveal>
      </ParallaxSection>
      
      <ScrollReveal direction="up" delay={0.2} duration={0.8}>
        <About />
      </ScrollReveal>
      
      <ScrollReveal direction="up" delay={0.3} duration={0.8}>
        <Contact />
      </ScrollReveal>
      
      <ScrollReveal direction="up" delay={0.2} duration={0.8}>
        <Map />
      </ScrollReveal>
    </>
  )
}

export default HomePage
